import { connect } from 'react-redux';
import ProgramRow from './ProgramRow';
import { sortProgramsRequest, updateProgramFlag } from '../../../../../store/actions/programs.actions';

const mapDispatchToProps = { sortProgramsRequest, updateFlag: updateProgramFlag };

const mapStateToProps = (state) => { 
    return { };
 };

export default connect(mapStateToProps, mapDispatchToProps)(ProgramRow);